Object.defineProperty(exports, "__esModule", {
  value: true
});

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultPixels = 500; /**
                          * Airbnb Scroll Depth Logging
                          * ============================================================================
                          *
                          * Used with Airbnb.Tracking to generate scroll depth logging events
                          */

exports['default'] = function (instance) {
  var registered = false;

  // eslint-disable-next-line no-param-reassign
  instance.registerScrollDepthTracking = function () {
    function registerScrollDepthTracking(element, container) {
      var _this = this;

      var px = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPixels;

      if (registered) {
        return;
      }

      var node = element || window;
      var doc = container || document;
      var lastScrollPosition = 0;

      var pixels = px || defaultPixels;

      node.addEventListener('scroll', (0, _throttle2['default'])(function () {
        var scrollPosition = node === window ? window.pageYOffset : node.scrollTop;

        if (scrollPosition > lastScrollPosition) {
          lastScrollPosition += pixels;

          var docHeight = doc.nodeType === 9 ? Math.max(doc.documentElement.offsetHeight, doc.documentElement.scrollHeight) : doc.innerHeight;

          _this.logEvent({
            event_name: 'scrolling',
            event_data: {
              increments: pixels,
              scrollPosition: scrollPosition,
              documentHeight: docHeight
            }
          });
        }
      }));

      registered = true;
    }

    return registerScrollDepthTracking;
  }();
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/scrollDepth.js
// module id = 479
// module chunks = 168707334958949